import { Outlet, Route, Routes } from "react-router-dom";
import { QueryRequestProvider } from "./core/QueryRequestProvider";
import { QueryResponseProvider } from "./core/QueryResponseProvider";
import Table from "./table/Table";
import EditUserWrapper from "./edit/EditUserWrapper";
import DetailUserWrapper from "./detail/DetailUserWrapper";
import CreateUserWrapper from "./create/CreateUserWrapper";

const UserManagementPage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path="/"
          element={
            <>
              <QueryRequestProvider>
                <QueryResponseProvider>
                  <Table />
                </QueryResponseProvider>
              </QueryRequestProvider>
            </>
          }
        />
        <Route
          path="/create"
          element={
            <>
              <CreateUserWrapper />
            </>
          }
        />

        <Route
          path="/edit/:id"
          element={
            <>
              <>
                <EditUserWrapper />
              </>
            </>
          }
        />

        <Route
          path="/detail/:id"
          element={
            <>
              <DetailUserWrapper />
            </>
          }
        />
      </Route>
    </Routes>
  );
};

export default UserManagementPage;
